export default "__VITE_ASSET__PEzoyhBh__"